import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import SimuladorNumericInput from "./SimuladorNumericInput";
import { truncar } from "../../Helpers/Truncar";


export const SimuladorCobranzaOR = ({ rango = null, setIncentivoRecuperacion }) => {
    
    const [state, setState] = useState({
        meta: 0,
        real: 0,
        cumplimiento: 0,
        porcentaje: 0,
        incentivo: 0,
    });
    const handleChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
    };
    useEffect(() => {
        if (Number(state.meta !== 0) && Number(state.real !== 0)) {
            const cumplimiento = truncar((Number(state.real) / Number(state.meta)) * 100);
            var porcentaje = 0;
            var incentivo = 0;
            if (rango !== null) {
                rango.forEach((index) => {
                    if (index.minimo <= state.meta && index.maximo >= state.meta) {
                        porcentaje = index.porcentaje;
                        incentivo =
                            (Number(state.real)) * index.porcentaje;
                    }
                });
            }

            setState({
                ...state,
                cumplimiento,
                porcentaje: porcentaje * 100,
                incentivo,
            });

            setIncentivoRecuperacion(incentivo)
        }
    }, [state.meta, state.real]);
    return (
        <div className="simulador-incentivo-vendedor-input">
            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">Real recuperado del mes</div>
                    <SimuladorNumericInput
                        name="real"
                        label=""
                        value={state.real}
                        disabled={false}
                        onChange={handleChange}
                    />
                </div>
                <div className="input-section">
                    <div className="input-title-label">Dias de atraso</div>
                    <SimuladorNumericInput
                        name="meta"
                        label=""
                        value={state.meta}
                        disabled={false}
                        onChange={handleChange}
                        icono="numero"
                    />
                </div>
            </div>
            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label">% incentivo a ganar</div>
                    <SimuladorNumericInput
                        name="porcentaje"
                        label=""
                        value={state.porcentaje}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>
            </div>
            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label">Tu incentivo es de:</div>
                    <SimuladorNumericInput
                        name="incentivo"
                        label=""
                        value={state.incentivo}
                        disabled={true}
                        icono="pesos"
                        inputTotal="si"
                    />
                </div>
            </div>
        </div>
    );
};
